import ko from "knockout";

const renderAttribute = function (element, attribute, stringInfo, viewModel) {
    let stringKey, data, locale;

    if (!stringInfo || typeof stringInfo == "string") {
        stringKey = stringInfo;
        data = viewModel;
    } else {
        stringKey = stringInfo.name;
        data = stringInfo.data || viewModel;
        locale = stringInfo.locale;
    }

    if (!stringKey) {
        return;
    }

    const renderedString = ko.i18n.renderString(stringKey, data, locale);
    element.setAttribute(attribute, renderedString);
};

/**
 * <p>Binding handler for rendering localized strings. Parameters are:</p>
 * <dl>
 *  <dt>name</dt>
 *  <dd>the identifier of the string to render in the current locale</dd>
 *  <dt>data</dt>
 *  <dd>the data to perform token replacement against.</dd>
 *</dl>
 * <pre class="prettyprint">
 * &lt;span data-bind="lString: {name: 'string.id', data: dataObj}"&gt;
 *   &lt;!-- localized string.id appears here, token replacement is done against dataObj --&gt;
 * &lt;/span&gt;
 * </pre>
 * <p>
 *   As a shorthand syntax, the string identifier can be passed directly. Token replacement
 *   will be performed against the current view model.
 * </p>
 * <pre class="prettyprint">
 * &lt;span data-bind="lString: 'string.id'"&gt;
 *   &lt;!-- localized string.id appears here, token replacement is done against the currently bound view model --&gt;
 * &lt;/span&gt;
 * </pre>
 *
 * @exports extensions/i18n/knockout-lAttr
 */
ko.bindingHandlers.lAttr = {
    init: function () {},
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        const attrInfo = ko.utils.unwrapObservable(valueAccessor());
        for (const attribute in attrInfo) {
            const stringInfo = ko.utils.unwrapObservable(attrInfo[attribute]);
            renderAttribute(element, attribute, stringInfo, viewModel);
        }
    },
};

export default ko.bindingHandlers.lAttr;
